import { FunnelEntryType } from './types'

export const FUNNEL_ENTRY_TYPE_OPTIONS = Object.values(FunnelEntryType).map(
  (value) => ({
    value,
    label: value,
  }),
)
